module.exports = __webpack_public_path__ + "static/media/Decisions_Step4_Image16b.8b338d57.webp";